<template>
  <div id="help_form">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.help_form')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-col span="22" offset="1">
      <van-col span="24" class="help_form_title"><span>*</span> {{ $t('column.feedback_type')}}</van-col>
      <van-col span="24">
        <van-row gutter="20">
          <van-col span="12">
            <van-col span="24" :class="type_i === 0 ? 'help_form_type_active help_form_type' : 'help_form_type'" @click.native="help_form_type_btn(0)"> {{ $t('column.general_lssue_feedback')}} </van-col>
          </van-col>
          <van-col span="12">
            <van-col span="24" :class="type_i === 1 ? 'help_form_type_active help_form_type' : 'help_form_type'" @click.native="help_form_type_btn(1)">{{ $t('column.cashout_withdrawa_issue')}}</van-col>
          </van-col>
          <van-col span="12">
            <van-col span="24" :class="type_i === 2 ? 'help_form_type_active help_form_type' : 'help_form_type'" @click.native="help_form_type_btn(2)">{{ $t('column.recharge_issue') }}</van-col>
          </van-col>
        </van-row>
      </van-col>
      <van-col span="24" class="help_form_title"><span>*</span> {{ $t('column.briefly_explain_problem') }}</van-col>
      <van-col span="24">
        <van-field
            v-model="message"
            rows="2"
            autosize
            class="help_form_text"
            type="textarea"
            maxlength="50"
            :placeholder="$t('column.describe_issue_in_brief')"
            show-word-limit
        />
      </van-col>
      <van-col span="24" class="help_form_title"><span>*</span> {{ $t('column.upload_screenshot')}}</van-col>
      <van-col span="24">
        <!-- 上传图片 -->
        <van-col span="24">
            <uploadImage
                ref="uploader"
                class="help_form_upload"
                :imageUrl="proof_img"
                :cos-config="cosConfig"
                v-if="iscos"
                @successUploadImage="handleSuccess"
                @errorUploadImage="handleError"
            />
        </van-col>
      </van-col>
      <van-col span="22" offset="1">
        <van-button class="help_form_btn" color="#FF61F5" block round @click="onClickButton">{{ $t('column.submit') }}</van-button>
      </van-col>
    </van-col>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import UploadImage from "./upload_image.vue";
import axios from "axios";
import {Dialog} from "vant";

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      message: undefined,
      iscos: false,
      proof_img: undefined,
      orderId: undefined,
      type_i: 0,
      cosConfig: {
        tmpSecretKey: undefined,
        tmpSecretId: undefined,
        bucket: undefined,
        region: undefined,
        sessionToken: '',
        domain: '',
      }
    }
  },
  created() {
    this.orderId = this.$route.query.order_id
    this.getcosConfig()
  },
  methods: {
    help_form_type_btn(i) {
      this.type_i= i
    },
    onClickButton() {
      Dialog.confirm({
        title: this.$t('column.are_you_sure_to_submit'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=feedback_exception",{
          params:{
            uid: uid,
            token: token,
            order_id: this.orderId,
            message: this.message,
            type: this.type_i,
            proof_img: this.proof_img
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.onClickLeft()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    getcosConfig(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=getCosSTS",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.cosConfig = res.data.data.sts
          this.iscos = true
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    handleSuccess(url) {
      // 上传成功
      console.log('====handleSuccess====')
      console.log(url)
      this.proof_img = url
    },
    handleError(err) {
      console.log('====handleError====')
      // 上传失败
      Toast(err);
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/help_feedback.vue